export interface State {
    isMobile: boolean;
    fromApp: boolean;
}

export const initialMobileState: State = {
    isMobile: false,
    fromApp: false
};
